import { render, staticRenderFns } from "./per-filter.vue?vue&type=template&id=21ed5f94&scoped=true"
import script from "./per-filter.vue?vue&type=script&lang=js"
export * from "./per-filter.vue?vue&type=script&lang=js"
import style0 from "./per-filter.vue?vue&type=style&index=0&id=21ed5f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed5f94",
  null
  
)

export default component.exports